/*
  2026-10-02 — Ligne de droits américains au panier (vitrine US).
  Pourquoi, règle, textes et interrupteur : snippets/-eib-trump-tax.liquid.
  Configuration : window.eibTrumpTax, écrite par ce snippet (part 'config').

  Ce script n'intercepte PAS fetch : il fournit une RÈGLE à la boucle de
  synchro du panier de -eib-auto-add-step (window.eibReglesPanier), qui la
  consulte quand les marchepieds sont en règle. Une écriture par passe ; la
  boucle relit le panier après chaque écriture et s'arrête d'elle-même dès
  qu'une lecture ne produit plus d'écriture. On n'écrit QUE s'il y a un
  écart entre l'état attendu et le panier : jamais de boucle.

  En plus de la règle :
  - au chargement, si Liquid a vu un écart (retour d'un changement de pays,
    panier d'avant la mise en ligne), on lance une synchro — hors /cart, où
    -eib-auto-add-step synchronise déjà au chargement ;
  - garde-fou de caisse : un clic « Check out » relit le panier et pose la
    ligne si la synchro n'a pas encore eu le temps de passer (client rapide
    sur la notification d'ajout).
*/
(function () {
  var C = window.eibTrumpTax;
  if (!C) return;

  var RACINE = C.racine && C.racine !== '/' ? C.racine.replace(/\/$/, '') : '';
  /* fetch d'avant l'interception de -eib-auto-add-step (exposé par lui) :
     les écritures du garde-fou de caisse ne relancent pas sa synchro. */
  function fetchDirect() {
    return (window.eibFetchDirect || window.fetch).apply(window, arguments);
  }

  /* UGS du produit vendu → variante de droits (prix > 0), dressée par le
     snippet à partir des UGS « DUTY-<UGS vendue> » des variantes. Vide hors
     vitrine US ou si le produit est éteint. */
  var TAXES = C.taxes || {};

  /* Quantité attendue par variante de la ligne de droits. Vide hors vitrine
     US ou si le produit est éteint : toute ligne présente sera retirée. */
  function attendu(cart) {
    var a = {};
    if (!C.applique) return a;
    (cart.items || []).forEach(function (i) {
      if (i.handle === C.handle) return;
      var v = TAXES[i.sku];
      if (v != null) a[v] = (a[v] || 0) + i.quantity;
    });
    return a;
  }

  /* La prochaine écriture nécessaire, ou null si le panier est en règle.
     Écritures par CLÉ de ligne, jamais par index (même règle que les
     marchepieds). Une ligne en double d'une même variante est retirée. */
  function prochaineEcriture(cart) {
    var a = attendu(cart);
    var vues = {};
    var items = cart.items || [];
    for (var k = 0; k < items.length; k++) {
      var l = items[k];
      if (l.handle !== C.handle) continue;
      var cible = a[l.variant_id] || 0;
      if (vues[l.variant_id] || cible === 0) {
        return { url: '/cart/change.js', corps: { id: l.key, quantity: 0 } };
      }
      vues[l.variant_id] = true;
      if (l.quantity !== cible) {
        return { url: '/cart/change.js', corps: { id: l.key, quantity: cible } };
      }
    }
    for (var v in a) {
      if (a[v] > 0 && !vues[v]) {
        var ligne = { id: parseInt(v, 10), quantity: a[v] };
        if (C.proprietes) ligne.properties = C.proprietes;   // « Why » : visible à la caisse
        return { url: '/cart/add.js', corps: { items: [ligne] } };
      }
    }
    return null;
  }

  /* Disjoncteur : si une écriture échoue en boucle (produit devenu
     indisponible, refus 422…), la boucle « repasser après toute écriture »
     relancerait la même requête sans fin. Au-delà de 10 écritures en 20 s,
     la règle se tait ; le garde-fou de caisse revérifie de toute façon. */
  var ecritures = [];
  function disjoncte() {
    var t = Date.now();
    ecritures = ecritures.filter(function (x) { return t - x < 20000; });
    if (ecritures.length >= 10) return true;
    ecritures.push(t);
    return false;
  }

  (window.eibReglesPanier = window.eibReglesPanier || []).push(function (cart) {
    var e = prochaineEcriture(cart);
    if (e && disjoncte()) {
      try { console.warn('[eib] ligne de droits : trop d\'écritures, synchro suspendue 20 s'); } catch (x) {}
      return null;
    }
    return e;
  });

  function auChargement() {
    if (!C.ecart) return;
    if (/\/cart(\/|$)/.test(window.location.pathname)) return;
    if (typeof window.eibSyncPanier === 'function') window.eibSyncPanier();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auChargement);
  else auChargement();

  /* ---- Garde-fou de caisse ---------------------------------------------
     Relit le panier, applique la règle (4 écritures au plus) ; résout à
     true si le panier a changé. */
  function verifier() {
    var n = 0;
    function passe() {
      return fetchDirect(RACINE + '/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var e = prochaineEcriture(cart);
          if (!e || n >= 4) return n > 0;
          n++;
          return fetchDirect(RACINE + e.url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(e.corps)
          }).then(passe);
        });
    }
    return passe();
  }

  var verifie = false;
  window.addEventListener('pageshow', function () { verifie = false; });  // retour arrière (bfcache)
  document.addEventListener('submit', function (ev) {
    var bouton = ev.submitter;
    if (verifie || !bouton || bouton.name !== 'checkout') return;
    if (!C.applique && !C.ecart) return;
    ev.preventDefault();
    var formulaire = ev.target;
    var delai = new Promise(function (ok) { setTimeout(function () { ok(false); }, 4000); });
    Promise.race([verifier(), delai])
      .catch(function () { return false; })
      .then(function (aEcrit) {
        verifie = true;
        if (aEcrit) {
          /* Le panier vient de changer : le formulaire porte des updates[]
             périmés, que Shopify refuserait (« Cart changed »). Quantités et
             note sont déjà enregistrées côté serveur : droit à la caisse. */
          window.location.href = RACINE + '/checkout';
          return;
        }
        if (formulaire.requestSubmit) {
          formulaire.requestSubmit(bouton);
        } else {
          var champ = document.createElement('input');
          champ.type = 'hidden';
          champ.name = 'checkout';
          formulaire.appendChild(champ);
          formulaire.submit();
        }
      });
  }, true);
})();
